// Orange County, FL city SEO data
// Each city has: slug, name, displayName, styles (3), nearby (3 slugs)

export const cities = [
  {
    slug: 'alafaya-fl',
    name: 'Alafaya',
    displayName: 'Alafaya, FL',
    styles: [
      'Modern pool designs in Alafaya',
      'Resort-style backyard pools in Alafaya',
      'Contemporary geometric pools in Alafaya',
    ],
    nearby: ['union-park-fl', 'wedgefield-fl', 'goldenrod-fl'],
  },
  {
    slug: 'apopka-fl',
    name: 'Apopka',
    displayName: 'Apopka, FL',
    styles: [
      'Luxury estate pools in Apopka',
      'Resort-style backyard pools in Apopka',
      'Modern pool designs in Apopka',
    ],
    nearby: ['lockhart-fl', 'ocoee-fl', 'maitland-fl'],
  },
  {
    slug: 'azalea-park-fl',
    name: 'Azalea Park',
    displayName: 'Azalea Park, FL',
    styles: [
      'Contemporary geometric pools in Azalea Park',
      'Modern pool designs in Azalea Park',
      'Resort-style backyard pools in Azalea Park',
    ],
    nearby: ['union-park-fl', 'goldenrod-fl', 'conway-fl'],
  },
  {
    slug: 'bay-lake-fl',
    name: 'Bay Lake',
    displayName: 'Bay Lake, FL',
    styles: [
      'Luxury estate pools in Bay Lake',
      'Resort-style backyard pools in Bay Lake',
      'Tropical lagoon-style pools in Bay Lake',
    ],
    nearby: ['lake-buena-vista-fl', 'windermere-fl', 'doctor-phillips-fl'],
  },
  {
    slug: 'belle-isle-fl',
    name: 'Belle Isle',
    displayName: 'Belle Isle, FL',
    styles: [
      'Luxury estate pools in Belle Isle',
      'Contemporary geometric pools in Belle Isle',
      'Modern pool designs in Belle Isle',
    ],
    nearby: ['edgewood-fl', 'conway-fl', 'pine-hills-fl'],
  },
  {
    slug: 'conway-fl',
    name: 'Conway',
    displayName: 'Conway, FL',
    styles: [
      'Modern pool designs in Conway',
      'Luxury estate pools in Conway',
      'Resort-style backyard pools in Conway',
    ],
    nearby: ['belle-isle-fl', 'orlando-fl', 'azalea-park-fl'],
  },
  {
    slug: 'doctor-phillips-fl',
    name: 'Doctor Phillips',
    displayName: 'Doctor Phillips, FL',
    styles: [
      'Luxury estate pools in Doctor Phillips',
      'Resort-style backyard pools in Doctor Phillips',
      'Contemporary geometric pools in Doctor Phillips',
    ],
    nearby: ['windermere-fl', 'horizon-west-fl', 'bay-lake-fl'],
  },
  {
    slug: 'eatonville-fl',
    name: 'Eatonville',
    displayName: 'Eatonville, FL',
    styles: [
      'Modern pool designs in Eatonville',
      'Contemporary geometric pools in Eatonville',
      'Resort-style backyard pools in Eatonville',
    ],
    nearby: ['maitland-fl', 'fairview-shores-fl', 'winter-park-fl'],
  },
  {
    slug: 'edgewood-fl',
    name: 'Edgewood',
    displayName: 'Edgewood, FL',
    styles: [
      'Contemporary geometric pools in Edgewood',
      'Luxury estate pools in Edgewood',
      'Modern pool designs in Edgewood',
    ],
    nearby: ['belle-isle-fl', 'pine-hills-fl', 'oak-ridge-fl'],
  },
  {
    slug: 'fairview-shores-fl',
    name: 'Fairview Shores',
    displayName: 'Fairview Shores, FL',
    styles: [
      'Modern pool designs in Fairview Shores',
      'Resort-style backyard pools in Fairview Shores',
      'Contemporary geometric pools in Fairview Shores',
    ],
    nearby: ['eatonville-fl', 'maitland-fl', 'pine-hills-fl'],
  },
  {
    slug: 'goldenrod-fl',
    name: 'Goldenrod',
    displayName: 'Goldenrod, FL',
    styles: [
      'Contemporary geometric pools in Goldenrod',
      'Modern pool designs in Goldenrod',
      'Resort-style backyard pools in Goldenrod',
    ],
    nearby: ['union-park-fl', 'azalea-park-fl', 'winter-park-fl'],
  },
  {
    slug: 'horizon-west-fl',
    name: 'Horizon West',
    displayName: 'Horizon West, FL',
    styles: [
      'Luxury estate pools in Horizon West',
      'Resort-style backyard pools in Horizon West',
      'Modern pool designs in Horizon West',
    ],
    nearby: ['windermere-fl', 'winter-garden-fl', 'doctor-phillips-fl'],
  },
  {
    slug: 'hunters-creek-fl',
    name: 'Hunters Creek',
    displayName: 'Hunters Creek, FL',
    styles: [
      'Luxury estate pools in Hunters Creek',
      'Resort-style backyard pools in Hunters Creek',
      'Tropical lagoon-style pools in Hunters Creek',
    ],
    nearby: ['williamsburg-fl', 'southchase-fl', 'oak-ridge-fl'],
  },
  {
    slug: 'lake-buena-vista-fl',
    name: 'Lake Buena Vista',
    displayName: 'Lake Buena Vista, FL',
    styles: [
      'Resort-style backyard pools in Lake Buena Vista',
      'Tropical lagoon-style pools in Lake Buena Vista',
      'Luxury estate pools in Lake Buena Vista',
    ],
    nearby: ['bay-lake-fl', 'windermere-fl', 'doctor-phillips-fl'],
  },
  {
    slug: 'lake-butler-fl',
    name: 'Lake Butler',
    displayName: 'Lake Butler, FL',
    styles: [
      'Luxury estate pools in Lake Butler',
      'Contemporary geometric pools in Lake Butler',
      'Resort-style backyard pools in Lake Butler',
    ],
    nearby: ['windermere-fl', 'horizon-west-fl', 'winter-garden-fl'],
  },
  {
    slug: 'lockhart-fl',
    name: 'Lockhart',
    displayName: 'Lockhart, FL',
    styles: [
      'Modern pool designs in Lockhart',
      'Resort-style backyard pools in Lockhart',
      'Contemporary geometric pools in Lockhart',
    ],
    nearby: ['apopka-fl', 'pine-hills-fl', 'fairview-shores-fl'],
  },
  {
    slug: 'maitland-fl',
    name: 'Maitland',
    displayName: 'Maitland, FL',
    styles: [
      'Luxury estate pools in Maitland',
      'Contemporary geometric pools in Maitland',
      'Modern pool designs in Maitland',
    ],
    nearby: ['winter-park-fl', 'eatonville-fl', 'fairview-shores-fl'],
  },
  {
    slug: 'oak-ridge-fl',
    name: 'Oak Ridge',
    displayName: 'Oak Ridge, FL',
    styles: [
      'Modern pool designs in Oak Ridge',
      'Contemporary geometric pools in Oak Ridge',
      'Resort-style backyard pools in Oak Ridge',
    ],
    nearby: ['edgewood-fl', 'pine-hills-fl', 'hunters-creek-fl'],
  },
  {
    slug: 'oakland-fl',
    name: 'Oakland',
    displayName: 'Oakland, FL',
    styles: [
      'Luxury estate pools in Oakland',
      'Modern pool designs in Oakland',
      'Contemporary geometric pools in Oakland',
    ],
    nearby: ['winter-garden-fl', 'ocoee-fl', 'windermere-fl'],
  },
  {
    slug: 'ocoee-fl',
    name: 'Ocoee',
    displayName: 'Ocoee, FL',
    styles: [
      'Modern pool designs in Ocoee',
      'Resort-style backyard pools in Ocoee',
      'Luxury estate pools in Ocoee',
    ],
    nearby: ['winter-garden-fl', 'apopka-fl', 'oakland-fl'],
  },
  {
    slug: 'orlando-fl',
    name: 'Orlando',
    displayName: 'Orlando, FL',
    styles: [
      'Luxury estate pools in Orlando',
      'Resort-style backyard pools in Orlando',
      'Contemporary geometric pools in Orlando',
    ],
    nearby: ['winter-park-fl', 'belle-isle-fl', 'pine-hills-fl'],
  },
  {
    slug: 'pine-hills-fl',
    name: 'Pine Hills',
    displayName: 'Pine Hills, FL',
    styles: [
      'Modern pool designs in Pine Hills',
      'Contemporary geometric pools in Pine Hills',
      'Resort-style backyard pools in Pine Hills',
    ],
    nearby: ['lockhart-fl', 'fairview-shores-fl', 'orlando-fl'],
  },
  {
    slug: 'southchase-fl',
    name: 'Southchase',
    displayName: 'Southchase, FL',
    styles: [
      'Resort-style backyard pools in Southchase',
      'Modern pool designs in Southchase',
      'Tropical lagoon-style pools in Southchase',
    ],
    nearby: ['hunters-creek-fl', 'williamsburg-fl', 'oak-ridge-fl'],
  },
  {
    slug: 'union-park-fl',
    name: 'Union Park',
    displayName: 'Union Park, FL',
    styles: [
      'Modern pool designs in Union Park',
      'Contemporary geometric pools in Union Park',
      'Resort-style backyard pools in Union Park',
    ],
    nearby: ['alafaya-fl', 'goldenrod-fl', 'azalea-park-fl'],
  },
  {
    slug: 'wedgefield-fl',
    name: 'Wedgefield',
    displayName: 'Wedgefield, FL',
    styles: [
      'Luxury estate pools in Wedgefield',
      'Resort-style backyard pools in Wedgefield',
      'Modern pool designs in Wedgefield',
    ],
    nearby: ['alafaya-fl', 'union-park-fl', 'orlando-fl'],
  },
  {
    slug: 'williamsburg-fl',
    name: 'Williamsburg',
    displayName: 'Williamsburg, FL',
    styles: [
      'Resort-style backyard pools in Williamsburg',
      'Luxury estate pools in Williamsburg',
      'Tropical lagoon-style pools in Williamsburg',
    ],
    nearby: ['hunters-creek-fl', 'southchase-fl', 'doctor-phillips-fl'],
  },
  {
    slug: 'windermere-fl',
    name: 'Windermere',
    displayName: 'Windermere, FL',
    styles: [
      'Luxury estate pools in Windermere',
      'Resort-style backyard pools in Windermere',
      'Contemporary geometric pools in Windermere',
    ],
    nearby: ['doctor-phillips-fl', 'horizon-west-fl', 'bay-lake-fl'],
  },
  {
    slug: 'winter-garden-fl',
    name: 'Winter Garden',
    displayName: 'Winter Garden, FL',
    styles: [
      'Modern pool designs in Winter Garden',
      'Luxury estate pools in Winter Garden',
      'Resort-style backyard pools in Winter Garden',
    ],
    nearby: ['oakland-fl', 'ocoee-fl', 'horizon-west-fl'],
  },
  {
    slug: 'winter-park-fl',
    name: 'Winter Park',
    displayName: 'Winter Park, FL',
    styles: [
      'Luxury estate pools in Winter Park',
      'Contemporary geometric pools in Winter Park',
      'Modern pool designs in Winter Park',
    ],
    nearby: ['maitland-fl', 'eatonville-fl', 'orlando-fl'],
  },
];

export const getCityBySlug = (slug) => cities.find((c) => c.slug === slug);

export const poolImages = [
  // All locally-hosted, all sparkling-water swimming pool photos.
  // Self-hosting bypasses customer-assets.emergentagent.com which is
  // blocked on the production sub-domain.
  '/images/pool-1.webp', // modern rectangular pool with fountains
  '/images/pool-2.jpg',  // pool with waterfall + paver deck
  '/images/pool-3.jpg',  // kidney-shaped screen-enclosed pool with palm trees
  '/images/pool-4.jpg',  // screen-enclosed pool + spa + waterfall + fire pit
];

// Strict subset used for HERO and INTERIOR CITY BANNERS.
// Per client direction: banners must show ONLY sparkling pool water.
export const poolBanners = poolImages;

// Named image aliases for common uses
export const HERO_IMAGE = poolImages[0]; // modern rectangular pool with fountains
export const CITY_HERO_POOL = poolImages[2]; // kidney pool with palm trees
export const WATERFALL_POOL = poolImages[1]; // pool with waterfall

export const LOGO_URL = '/images/aps-logo.webp';

// County metadata used across pages
export const COUNTY = {
  name: 'Orange County',
  displayName: 'Orange County, FL',
  stateAbbrev: 'FL',
  // representative cities mentioned in copy
  featureCities: 'Orlando, Winter Park, Windermere, Doctor Phillips & Apopka',
};

// Site host used for absolute URLs in metadata, JSON-LD, sitemap, etc.
// Update this if the production sub-domain changes.
export const SITE_URL = 'https://orange.american-pools.com';
